import _slicedToArray from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useEffect, useState } from "react";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { FormControl } from "@material-ui/core";
import { isAfter, isValid } from "date-fns";
var DateTimePicker = function DateTimePicker(_a) {
  var id = _a.id,
    required = _a.required,
    onChange = _a.onChange,
    value = _a.value,
    validationError = _a.validationError,
    preventFutureDate = _a.preventFutureDate,
    _a$format = _a.format,
    format = _a$format === void 0 ? "MM/dd/yyyy" : _a$format,
    props = __rest(_a, ["id", "required", "onChange", "value", "validationError", "preventFutureDate", "format"]);
  var _useState = useState(validationError),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useState3 = useState(value),
    _useState4 = _slicedToArray(_useState3, 2),
    curValue = _useState4[0],
    setCurValue = _useState4[1];
  useEffect(function () {
    setError(validationError);
  }, [validationError]);
  useEffect(function () {
    setCurValue(value || null);
  }, [value]);
  var handleChange = function handleChange(date, _value) {
    setCurValue(date);
    onChange && onChange(date);
    if (!date && required) {
      setError("Required");
    } else if (!isValid(date)) {
      setError("Enter a valid date");
    } else if (preventFutureDate && date && isAfter(new Date(date), Date.now())) {
      setError("Date cannot be in the future");
    } else {
      setError("");
    }
  };
  return React.createElement(FormControl, {
    fullWidth: true,
    error: !!error,
    id: id
  }, React.createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils
  }, React.createElement(KeyboardDatePicker, Object.assign({
    format: format,
    value: curValue,
    disableFuture: preventFutureDate,
    error: Boolean(error),
    helperText: error,
    required: required,
    defaultValue: value || null
  }, props, {
    onChange: handleChange
  }))));
};
export default DateTimePicker;